import * as Yup from 'yup';
import base64Image from './base64Image/index.js';
import { date, datetime, time, } from './date/index.js';
import password from './password/index.js';
import phoneNumber from './phoneNumber/index.js';
import zipCode from './zipCode/index.js';
import email from './email/index.js';
import integer from './integer/index.js';
import url from './url/index.js';
import sanitizeForHTMLJS from './sanitizeForHTMLJS/index.js';
// Add custom rules
Yup.addMethod(Yup.string, 'base64Image', base64Image);
Yup.addMethod(Yup.string, 'date', date);
Yup.addMethod(Yup.string, 'datetime', datetime);
Yup.addMethod(Yup.string, 'time', time);
Yup.addMethod(Yup.string, 'password', password);
Yup.addMethod(Yup.string, 'phoneNumber', phoneNumber);
Yup.addMethod(Yup.string, 'zipCode', zipCode);
Yup.addMethod(Yup.string, 'email', email);
Yup.addMethod(Yup.string, 'integer', integer);
Yup.addMethod(Yup.string, 'url', url);
Yup.addMethod(Yup.string, 'sanitizeForHTMLJS', sanitizeForHTMLJS);
export default Yup;
//# sourceMappingURL=index.js.map